var _defs, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPSignalHeatPump = function SvgPSignalHeatPump(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684.2 480.2"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "342.1 46.1 342.1 55.1 304.1 55.1 304.1 237.1 304.1 237.2 420.1 237.2 420.1 396.1",
    fill: "none",
    stroke: "#1c9d5b",
    strokeMiterlimit: 10,
    strokeWidth: "2px"
  })));
};
export default SvgPSignalHeatPump;